import {Component, Inject, OnInit, NgModule} from '@angular/core';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { AgentDetailDTO } from '../../../tsScripts/DTO/AgentDetailDTO';
import { ProfileHttp } from '../../../tsScripts/providers/http/ProfileHttp';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProfileSecurity } from './ProfileSecurity';
import { ModalChangeMyProfilePhoto } from './ModalChangeMyProfilePhoto';
import { ModalEditUserProfile } from './ModalEditUserProfile';
import { ModalDeleteUserProfilePhoto } from './ModalDeleteUserProfilePhoto';
import { LoadingButtonModule } from 'directives/LoadingButton';
import { LudyUiReactModule } from 'components/ludyUIReact/LudyUiReactModule';
import { ImageErrorModule } from 'directives/ImageError';
import { TooltipsModule } from 'directives/Tooltips';
import { LigthGalleryModule } from 'directives/LigthGallery';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileLobby } from 'components/lobby/profileLobby/ProfileLobby';
import { Aws } from 'providers/services/aws';
import { ProfileBasicData } from './ProfileBasicData';


@Component({
    selector: 'my-profile',
    templateUrl: "../../../views/components/myProfile/myProfile.html",
    providers: [],
    styleUrls: ["../../../styles/agent.css"]
})

export class MyProfile implements OnInit {

    loading: boolean;
    errorMessage: string;
    active: number;
    profileModel: ProfileModel;
    responseOKStatus: boolean;

    constructor(private ProfileHttp: ProfileHttp) {
        this.loading = false;
        this.active = 1;
        this.profileModel = new ProfileModel();
        this.responseOKStatus = false;
    }

    changeTab(tab: number) {
        this.active = tab;
        this.refresh();
    }
    
    refresh() {
        this.profileModel.getLoggedUserData();
    }

    ngOnInit() {
        this.profileModel.getLoggedUserData = () => {
            this.loading = true;
            this.ProfileHttp.getLoggedUserData({}).then((response: AgentDetailDTO) => {
                this.loading = false;
                this.responseOKStatus = true;
                this.profileModel.userData = response;
            }, (error: ErrorDTO) => {
                this.loading = false;
                this.errorMessage = error.errorMessage;
            });
        }
        this.profileModel.getLoggedUserData();
    }
}


@NgModule({
    declarations: [
        MyProfile,
        ProfileBasicData,
        ProfileSecurity,
        ModalChangeMyProfilePhoto,
        ModalEditUserProfile,
        ModalDeleteUserProfilePhoto
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LoadingButtonModule,
        LudyUiReactModule,
        ImageErrorModule,
        TooltipsModule,
        LigthGalleryModule,
        NgbModalModule.forRoot(),
    ],
    providers: [
        ProfileHttp,
        Aws,
        ProfileLobby
    ],
    entryComponents: [
        ProfileBasicData,
        ProfileSecurity,
        ModalChangeMyProfilePhoto,
        ModalEditUserProfile,
        ModalDeleteUserProfilePhoto],
    exports: [MyProfile]
})
export class ProfilePruebaModule {
}

export class ProfileModel {
    userData: AgentDetailDTO;
    getLoggedUserData: () => void;
    constructor() {
    }
}